import type { ShopperProducts } from '@/scapi';
import type { ContentFolder } from '@/lib/api/content-folders.server';

type Category = ShopperProducts.schemas['Category'];

export function isContentFolderVisibleInMenu(folder: ContentFolder): boolean {
    return folder.showInMenu === true;
}

/** Recursively keeps only folders flagged with `showInMenu`. */
export function filterContentFoldersForMenu(folders: ContentFolder[]): ContentFolder[] {
    return folders.filter(isContentFolderVisibleInMenu).map((folder) => ({
        ...folder,
        folders: folder.folders ? filterContentFoldersForMenu(folder.folders) : undefined,
    }));
}

export function findContentFolderById(folders: ContentFolder[], id: string): ContentFolder | undefined {
    for (const folder of folders) {
        if (folder.id === id) return folder;
        if (folder.folders?.length) {
            const result = findContentFolderById(folder.folders, id);
            if (result) return result;
        }
    }
    return undefined;
}

/**
 * Maps editorial content folders to the SCAPI Category shape used by navigation menus (L1 → L2 → L3).
 */
export function mapContentFoldersToCategories(contentFolders: ContentFolder[]): Category[] {
    return contentFolders.map((folder) => ({
        id: folder.id,
        name: folder.name,
        c_url: folder.path,
        categories: folder.folders?.map((sub) => ({
            id: sub.id,
            name: sub.name,
            c_url: sub.path,
            categories: sub.folders?.map((leaf) => ({
                id: leaf.id,
                name: leaf.name,
                c_url: leaf.path,
            })),
        })) as Category[] | undefined,
    }));
}
